/**
 * Keeps a URL up to its first `?` or `#`. Query strings and fragments carry credentials — the
 * password-reset `token`, SAML's `temp_token` — and ids passed as parameters, so no URL leaves the
 * browser in telemetry or a session replay with them attached. `undefined` and `''` pass through.
 */
export function pathOnly(url: string): string;
export function pathOnly(url: string | undefined): string | undefined;
export function pathOnly(url: string | undefined) {
  if (!url) return url;
  const cut = url.search(/[?#]/);
  return cut === -1 ? url : url.slice(0, cut);
}
